import { useEffect } from "react";


export default function ThunderboltAnimation({ playerRef, opponentRef, onComplete }) {
  useEffect(() => {
    const opponentEl = opponentRef.current;
    if (!opponentEl) return;

    const container = opponentEl.closest(".battle-bg");
    const oRect = opponentEl.getBoundingClientRect();
    const cRect = container.getBoundingClientRect();

    const endX = (oRect.left + oRect.width / 2) - cRect.left;
    const endY = (oRect.top + oRect.height / 2) - cRect.top;
    const startY = endY - 150;

    const bolt = document.createElement("div");
    bolt.className = "bolt-zigzag";
    bolt.style.left = `${endX}px`;
    bolt.style.top = `${startY}px`;
    container.appendChild(bolt);

    // Flash on hit
    const flash = document.createElement("div");
    flash.className = "bolt-flash";
    flash.style.left = `${endX}px`;
    flash.style.top = `${endY}px`;
    container.appendChild(flash);

    const sparks = [];
    setTimeout(() => {
      for (let i = 0; i < 20; i++) {
        const spark = document.createElement("div");
        spark.className = "bolt-spark";
        spark.style.left = `${endX}px`;
        spark.style.top = `${endY}px`;

        const a = Math.random() * Math.PI * 2;
        const d = 20 + Math.random() * 20;
        const dx = Math.cos(a) * d;
        const dy = Math.sin(a) * d;
        spark.style.setProperty("--dx", `${dx}px`);
        spark.style.setProperty("--dy", `${dy}px`);
        container.appendChild(spark);
        sparks.push(spark);
      }

      opponentEl.classList.add("bolt-hit");
      setTimeout(() => {
        opponentEl.classList.remove("bolt-hit");
        sparks.forEach(s => s.remove());
        bolt.remove();
        flash.remove();
        onComplete();
      }, 300);
    }, 400);

    return () => {
      bolt.remove();
      flash.remove();
      sparks.forEach(s => s.remove());
    };
  }, [playerRef, opponentRef, onComplete]);

  return null;
}

ThunderboltAnimation.moveType = "electric";
